let seq = 0;
const listeners = new Set();

export function showToast(title, tone = 'ok', text = '') {
  const item = {
    id: ++seq,
    title: title || '',
    text: text || '',
    tone: tone === 'error' || tone === 'danger' ? 'error' : tone === 'warning' ? 'warn' : tone === 'info' ? 'info' : 'ok',
    at: Date.now(),
  };
  listeners.forEach((fn) => fn(item));
  return item.id;
}

export function subscribeToasts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function formatToastTime(ts = Date.now()) {
  return new Date(ts).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}
